// extracted by mini-css-extract-plugin
export var container = "_ao-0";
export var icon = "_ao-1";
export var text = "_ao-2";